<template>
<div>    
    <component-loader :progress="reviewPercentLoader || 90" :unlimitedProgress="reviewPercentLoader ? false : true" :class="{'progress-bar': reviewPercentLoader}" v-if="showLoader" :activeClose="true" v-on:close="showLoader = false"></component-loader> 

    <div class="section-moderation" v-if="activeModeration" :class="[{'section-inbox': activeInbox() && showInbox()}]">
      <!-- <div class="pages-sidebar" :class="{'contract': !advancedTabs}" v-click-outside="contractTabs"> -->
      <div class="pages-sidebar" :class="{'contract': tabsIsMinimize}">
        <div class="table-title" @click="toggleExpandTabs">
            <p>{{$t('dash.moderation.title')}}</p>
        </div>
        <div class="show-setting">
          <!-- <i class="material-icons expand-btn minimize" @click="toggleExpandTabs" v-if="advancedTabs">navigate_before</i>
          <i class="material-icons expand-btn maximize" @click="toggleExpandTabs" v-if="!advancedTabs">navigate_next</i> -->
          <i class="material-icons expand-btn minimize" @click="toggleExpandTabs" v-if="!tabsIsMinimize">navigate_before</i>
          <i class="material-icons expand-btn maximize" @click="toggleExpandTabs" v-if="tabsIsMinimize">navigate_next</i>
        </div>
        <div class="search-page">
          <vs-input
            v-model="pageFilter"
            :class="{'input': true}"
            color="#B20564"
            class="inputx"
            icon-after="true"  icon="search"
            :placeholder="$t('dash.settings.user.label.page_filter')"
          />
        </div>
        <div class="filter-selected">
          <span @click="filterSelected = !filterSelected">{{ $t(!filterSelected ? `dash.pages-sidebar.filter-selected${selectedPages.length > 1 ? '-multi' : ''}` : 'dash.pages-sidebar.filter-all') }}</span>
          <Tooltip :text="$t(!selectAllPages ? `dash.pages-sidebar.cta-select-all` : 'dash.pages-sidebar.cta-unselect-all')" position="top">
            <img v-if="!selectAllPages" @click="selectAllPages = !selectAllPages" alt="Select all pages" src="../../../assets/img/select_all_icon.svg">
            <img v-else @click="selectAllPages = !selectAllPages" alt="Unselect pages" src="../../../assets/img/unselect_icon.svg">
            &nbsp;
          </Tooltip>
          <Tooltip class="sort-toggle-tooltip" :text="$t(isPageSortAlpha ? 'dash.select-page.sort-default' : 'dash.select-page.sort-alpha')" position="top">
            <i class="fa-solid fa-arrow-down-a-z sort-toggle" :class="{ active: isPageSortAlpha }" @click="togglePageSortMode"></i>
            &nbsp;
          </Tooltip>
        </div>
        <ul v-if="groups && pagesActive">
          <li class="group" v-for="group in sortByPageName(groups)" :key="group.id" :class="[{'show': group.show, 'hide': !checkPagesInGroup(group) || checkGroupFilter(group)}]">
            <div class="group-wrapper">
              <img v-if="!group.show" alt="show group" class="show-group" src="../../../assets/img/icon-show-group.svg" @click="toggleShowGroup(group)"/>
              <img v-else alt="hide group" class="hide-group" src="../../../assets/img/icon-hide-group.svg" @click="toggleShowGroup(group)"/>
              <div class="group-content">
                <Tooltip :text="group.name" position="top">
                  <div class="group-name messagedefilant"><div :data-text="group.name"><span>{{ group.name }}</span></div></div>
                  &nbsp;
                </Tooltip>
              </div>
              <div class="checkbox">
                <input
                  type="checkbox"
                  :id="`groups-${group.id}`"
                  name="groups[]"
                  :value="group.id"
                  v-model="selectedGroups"
                  @change="checkGroup(group)"
                >
                <span class="checkmark" :class="[{deselect: checkAllPagesGroupSelected(group)}]">
                  <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                  <span class="material-icons">remove</span>
                </span>
              </div>
            </div>
            <ul>
              <div v-for="item in sortByPageName(group.pages, findPage)" :key="item">
                <li class="page" v-if="findPage(item)"
                      @click="accessNotActived(findPage(item)) && !missingFacebookParent(findPage(item)) ? confirmActiveAccess(item) : null"
                      :class="[{ disabled: pageUnavailable(findPage(item)), 'hide': !checkPageFilter(findPage(item)) || !checkSelected(findPage(item)) }]">
                  <div class="page-wrapper" :class="{disabled: pageUnavailable(findPage(item))}">
                    <i v-if="loadingPages && loadingPages[item] && loadingPages[item].loading" class="fa-sharp fa-solid fa-spinner-third loading-page"></i>
                    <div class="checkbox" v-else>
                      <input
                        type="checkbox"
                        :id="`pages-${findPage(item).id}`"
                        name="pages[]"
                        :value="pagesActive.findIndex(p => p.id == findPage(item).id)"
                        :disabled="pageUnavailable(findPage(item))"
                        v-model="selectedPages"
                        v-on:click="updateSelected(pagesActive.findIndex(p => p.id == findPage(item).id))"
                        :class="{'radio': (!['facebook', 'instagram', 'linkedin', 'tiktok'].includes(findPage(item).network) && activeInbox()) || !activeInbox()}"
                      >
                      <span class="checkmark">
                        <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                      </span>
                    </div>
                    <div class="page-content">
                      <Tooltip :text="pageTooltip(findPage(item))" position="top">
                        <page-image-avatar :page="findPage(item)"/>
                        <div class="page-name messagedefilant"><div :data-text="findPage(item).name"><span>{{ findPage(item).name }}</span></div></div>
                        &nbsp;
                      </Tooltip>
                      <Tooltip class="count" v-if="findPage(item).count_events" :text="`${findPage(item).count_events} ${$t(`dash.inbox.page-sidebar.count-event${findPage(item).count_events > 1 ? 's' : ''}`)}`" position="top">
                        <div class="count-events">{{ findPage(item).count_events }}</div>
                        &nbsp;
                      </Tooltip>
                    </div>
                  </div>
                </li>
              </div>
            </ul>
          </li>
          <li class="page" v-for="{ item, index } in sortedPagesActive" :key="item.id" 
                  @click="accessNotActived(item) && !missingFacebookParent(item) ? confirmActiveAccess(item) : null"
                  :class="[{ current: selectedTab == index, disabled: pageUnavailable(item), 'hide': !checkPageFilter(item) || pageInGroup(item) || !checkSelected(item) }]">
            <div class="page-wrapper" :class="{disabled: pageUnavailable(item)}" v-if="!pageInGroup(item)">
              <div class="page-content">
                <Tooltip :text="pageTooltip(item)" position="top">
                  <page-image-avatar :page="item"/>
                  <div class="page-name messagedefilant"><div :data-text="item.name"><span>{{ item.name }}</span></div></div>
                  &nbsp;
                </Tooltip>
                <Tooltip class="count" v-if="item.count_events" :text="`${item.count_events} ${$t(`dash.inbox.page-sidebar.count-event${item.count_events > 1 ? 's' : ''}`)}`" position="top">
                  <div class="count-events">{{ item.count_events }}</div>
                  &nbsp;
                </Tooltip>
              </div>
              <i v-if="loadingPages && loadingPages[item.id] && loadingPages[item.id].loading" class="fa-sharp fa-solid fa-spinner-third loading-page"></i>
              <div class="checkbox" v-else>
                <input
                  type="checkbox"
                  :id="`pages-${item.id}`"
                  name="pages[]"
                  :value="index"
                  :disabled="pageUnavailable(item)"
                  v-model="selectedPages"
                  v-on:click="updateSelected(index)"
                  :class="{'radio': (!['facebook', 'instagram', 'linkedin', 'tiktok'].includes(item.network) && activeInbox()) || !activeInbox()}"
                >
                <span class="checkmark">
                  <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                </span>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="filters-wrapper top" v-if="((pinsData.pages && !['linkedin', 'instagram'].includes(pinsData.pages.network)) || (pagesActive && pagesActive[selectedTab] && pagesActive[selectedTab].network == 'google')) && !(activeInbox() && showInbox())">
        <vs-button color="#2F1937" :class="{'select': choosemoderation}" @click="choosemoderation = true, chooseconversation = false" v-if="pagesActive && pagesActive[selectedTab] && pagesActive[selectedTab].network != 'google'">
          {{$t('dash.moderation.moderationbutton')}}
          </vs-button> 
        <vs-button color="#2F1937" :class="{'select': chooseconversation}" @click="findConversations()" v-if="pagesActive && pagesActive[selectedTab] && pagesActive[selectedTab].network != 'google'">
          {{$t('dash.moderation.conversationbutton')}}
        </vs-button>
        <vs-button color="#2F1937" class="w100" :class="{'select': chooseReviews}" v-if="pagesActive && pagesActive[selectedTab] && pagesActive[selectedTab].network == 'google'" @click="getReviews()">
          {{$t('dash.moderation.reviewsbutton')}}
        </vs-button>
      </div>
     
      <div class="page-selected" v-if="selectedPages && selectedPages.length">
        <page-image-avatar :page="pagesActive[selectedPages[0]]"/>
        <p class="page-name">{{ pagesActive[selectedPages[0]] && pagesActive[selectedPages[0]].name }}</p>
      </div>
      <div class="tables-wrapper">

        <div class="partie-inbox inbox" v-if="activeInbox() && showInbox()">
          
          <component-inbox :page="pagesActive[selectedTab]" :pages="selectedPages.map(p => pagesActive[p])" :allPages="selectAllPages" @updateLoadingPages="updateLoadingPages" @updateCountEvents="updateCountEvents"></component-inbox>

        </div>
        
        <div class="reviews" v-else-if="pagesActive && pagesActive[selectedTab] && pagesActive[selectedTab].network == 'google'">
          <template v-if="reviews">
            <div class="average-rating">{{ reviews.averageRating.toFixed(1) }}</div>
            <div class="stars-rating">
              <div class="background" :style="`width:${(reviews.averageRating/5*100).toFixed(0)-1}%`"></div>
              <img alt="stars rate" src="../../../assets/img/star_icon.png"/>  
            </div>
            <div class="total-review-count">{{ reviews.totalReviewCount }} ({{ $t('dash.moderation.review') }})</div>
            <div class="sort">
              <div class="sort_by">{{ $t('dash.moderation.reviews.sort_by') }}</div>
              <div class="btn" :class="{active: sortReviews == 'most_recent'}" @click="sortReviewsBy('most_recent')">{{ $t('dash.moderation.reviews.sort.most_recent') }}</div>
              <div class="btn" :class="{active: sortReviews == 'best'}" @click="sortReviewsBy('best')">{{ $t('dash.moderation.reviews.sort.best') }}</div>
              <div class="btn" :class="{active: sortReviews == 'least_good'}" @click="sortReviewsBy('least_good')">{{ $t('dash.moderation.reviews.sort.least_good') }}</div>
            </div>
            <ul class="reviews">
              <li v-for="(review, key) in reviews.reviews" :key="key">
                <div class="user">
                  <img :src="review.reviewer.profilePhotoUrl" :alt="review.reviewer.displayName">
                  <div class="name">{{ review.reviewer.displayName }}</div>
                </div>
                <div class="stars-rating">
                  <div class="background" :style="`width:${(review.starRating/5*100).toFixed(0)-1}%`"></div>
                  <img alt="stars rate" src="../../../assets/img/star_icon.png"/>  
                </div>
                <Tooltip
                  :text="dateFormat(review.updateTime)"
                  position="top"
                  class="date"
                >
                  <span>{{ dateFromNow(review.updateTime) }}</span>
                  &nbsp;
                </Tooltip>
                <div class="comment" v-if="review.comment">{{ review.comment }}</div>
                <div class="reply" v-if="review.reviewReply">
                  <template v-if="!replyReview || review.reviewId != replyReview.reviewId">
                    <div class="name">{{ $t('dash.moderation.reviews.reply.name') }}</div>
                    <Tooltip
                      :text="dateFormat(review.reviewReply.updateTime)"
                      position="top"
                      class="date"
                    >
                      <span>{{ dateFromNow(review.reviewReply.updateTime) }}</span>
                      &nbsp;
                    </Tooltip>
                    <div class="comment">{{ review.reviewReply.comment }}</div>
                  </template>
                  <div class="cta" v-if="!replyReview || review.reviewId != replyReview.reviewId">
                    <div class="edit" @click="openReplyToReview(review, 'edit')">
                      <span class="material-icons">edit</span>
                      {{ $t('dash.moderation.reviews.reply.edit') }}
                    </div>
                    <div class="remove" @click="deleteReplyToReview(review)">
                      <span class="material-icons">delete</span>
                      {{ $t('dash.moderation.reviews.reply.remove') }}
                    </div>
                  </div>
                  <div class="reply-review" v-else>
                    <div class="name">{{ $t('dash.moderation.reviews.reply.name') }}</div>
                    <vs-textarea
                      vs-size="large"
                      color="#B20564"
                      name="reply"
                      :placeholder="$t('dash.moderation.reviews.reply.description_placeholder')"
                      v-model="replyContent"
                      :counter="4000" :counter-danger.sync="counterDanger"
                    />
                    <vs-button color="#1a73e8" @click="sendReplyToReview(replyReview)" :disabled="replyContent.length == 0">
                      {{$t('dash.moderation.reviews.reply.add')}}
                    </vs-button> 
                  </div>
                </div>
                <template v-else>
                  <div class="cta" v-if="!replyReview || review.reviewId != replyReview.reviewId">
                    <div class="add" @click="openReplyToReview(review, 'add')">
                      <span class="material-icons">add_circle</span>
                      {{ $t('dash.moderation.reviews.reply.add') }}
                    </div>
                  </div>
                  <div class="reply-review" v-else>
                    <div class="name">{{ $t('dash.moderation.reviews.reply.name') }}</div>
                    <vs-textarea
                      vs-size="large"
                      color="#B20564"
                      name="reply"
                      :placeholder="$t('dash.moderation.reviews.reply.description_placeholder')"
                      v-model="replyContent"
                      :counter="4000" :counter-danger.sync="counterDanger"
                    />
                    <vs-button color="#1a73e8" @click="sendReplyToReview(replyReview)" :disabled="replyContent.length == 0">
                      {{$t('dash.moderation.reviews.reply.add')}}
                    </vs-button> 
                  </div>
                </template>
                <span class="clearBoth"></span>
              </li>
            </ul>
          </template>
          <div class="no-reviews" v-else-if="!showLoader">
            {{ $t('dash.reviews.no_reviews') }}
          </div>
        </div>

        <div class="partie-conversation" v-else-if="chooseconversation == true">

            <div class="tabs-content"> 
            <div class="conv">
            <div class="header">
              <div class="title">
                <span class="name" v-if="pagesActive && pagesActive[selectedTab]">{{ pagesActive[selectedTab].name }}</span>
              </div>
              <div class="frequency-wrapper">
                <vs-button color="primary" type="filled" icon="refresh" @click="reloadDiscussion()"></vs-button>
                <Tooltip :text="$t('dash.frequency.refresh')" position="top">
                  <select v-model="refresh.frequency" @change="reloadDiscussion()">
                    <option v-for="(freq, key) in refresh.allowed"
                      :key="key"
                      :value="freq"
                      :style="freq ? '' : 'color: gray'"
                    >{{ freq ? freq + ' sec' : $t('dash.posts.no_refresh') }}</option>
                  </select>
                  &nbsp;
                </Tooltip>
              </div>
            </div>
            <div class="content"> 
                <ul>
                  <li>
                  <component-conversations
                  :page="pagesActive[selectedTab]"
                  :conversationsFromModeration="conversationsFromModeration"
                  v-on:showDiscussion="showDiscussion"
                  :refreshdicussion="refreshdicussion"
                  ></component-conversations>
                  
                </li>
          </ul>
            </div>
          </div>
          <div class="discu">
            <div class="header">
            </div>
            <div class="content"> 
              <component-discussion
              
            v-if="discussion"
            :discussion="discussion"
            :discussionuser="discussionuser"
            :attachment="attachment"
            :page="pagesActive[selectedTab]"
            v-on:messageSend="messageSend"
            v-on:reactToMessage="reactToMessage"
            ></component-discussion>
            </div>
          </div>
        </div>
            
          
        </div>


        <div class="partie-moderation" v-else-if="choosemoderation == true">

        <div class="tabs-content"> 
          
          <div class="feed">
            <div class="header">
              <div class="title">
                {{ $t('dash.moderation.my-feed') }} 
                <span class="name" v-if="pagesActive && pagesActive[selectedTab]">{{ pagesActive[selectedTab].name }}</span>
                <Tooltip
                  :text="$t('dash.moderation.total_count_comments')"
                  position="top"
                  class="total-count-comments"
                > 
                  <span>{{ totalCountComments }}</span>
                  &nbsp;
                </Tooltip>
              </div>
              <div class="cta">
                <vs-button class="refresh-feed" @click="getPosts()" vs-type="flat" icon="refresh"></vs-button>
              </div>
            </div>
            <div class="content"> 
              <!--<div class="pagination-posts previous-post" v-if="posts.paging && posts.paging.previous">
                <vs-button class="page-btn btn-large" @click="paginationPosts('previous')">
                  {{ $t("dash.moderation.previous-posts")}}
                </vs-button>
              </div>-->   
              <component-posts-feed
                :key="`moderation-table-page-${idReload}`"
                :gridData="posts"
                :name="'posts-feed'"
                :activeBadWordsDetection="activeBadWordsDetection"
                :badWordList="badWordList"
                v-if="posts"
                v-on:switchComment="switchComment"
                v-on:getPosts="getPosts"
                v-on:addPostLike="addPostLike"
                v-on:addPin="addPin"
                v-on:removePin="removePin"
                v-on:paginationPosts="paginationPosts"
                v-on:badWordsDetected="badWordsDetected"
                v-on:addCountComments="addCountComments"
              ></component-posts-feed>
              <div class="pagination-posts next-post" v-if="posts.paging && posts.paging.next || posts.paging && posts.paging.links">
                <vs-button class="page-btn btn-large" @click="paginationPosts('next')" vs-type="filled">
                  {{ $t("dash.moderation.next-posts")}}
                </vs-button>
              </div>
            </div>
          </div>
          <div class="pins">
            <div class="header">
              <div class="title">{{ $t('dash.moderation.pins') }}  <span class="name" v-if="pagesActive && pagesActive[selectedTab]">{{ pagesActive[selectedTab].name }}</span></div>
            </div>
            <div class="content"> 
              <component-posts-feed
                :key="'moderation-table-page-pins'"
                :gridData="pinsData"
                :name="'pins-feed'"
                :pins="true"
                :badWordList="badWordList"
                v-if="pins && pinsData"
                v-on:getPosts="getPosts"
                v-on:addPostLike="addPostLike"
                v-on:removePin="removePin"
              ></component-posts-feed>
            </div>
          </div>
          <div class="comments-bad-words">
            <div class="header">
              <div class="title">{{ $t('dash.moderation.comments-bad-words') }}</div>
              <div class="cta">
                <div class="bad-word-detection">
                  <vs-button class="manage-bad-words" @click="popupBadWords=true" vs-type="flat" icon="settings"></vs-button>
                  <vs-popup :title="$t('dash.moderation.add-remove-bad-words')" :active.sync="popupBadWords">
                    <vs-chips color="rgb(145, 32, 159)" :placeholder="$t('dash.moderation.new-bad-word')" v-model="badWordList" remove-icon="delete_forever" class="bad-words-list">
                      <vs-chip
                        :key="word"
                        @click="removeChipBadWord(word)"
                        v-for="word in badWordList" closable>
                        {{ word }}
                      </vs-chip>
                    </vs-chips>
                  </vs-popup>
                </div>
              </div>
            </div>
            <div class="content"> 
              <component-posts-feed
                :key="'moderation-table-page-pins'"
                :gridData="badWords"
                :name="'bad-words-feed'"
                :badWordsFeed="true"
                :badWordList="badWordList"
                v-if="badWords"
                v-on:deleteCommentWithBadWord="deleteCommentWithBadWord"
              ></component-posts-feed>
            </div>
          </div>
        </div>
        </div>
      </div>
     
    </div>
  </div>

</template>

<script>
import store from './../../../store/index.js'
import componentConversations from './../Conversations'
import componentDiscussion from './../Discussion'
import componentPostsFeed from './../PostsFeed'
import Posts from '../../mixins/Posts'
import User from '../../mixins/User'
import Insights from '../../mixins/Insights'
import Pages from '../../mixins/Pages'
import Bots from '../../mixins/Bots'
import Groups from '../../mixins/Groups'
import Moderation from '../../mixins/Moderation'
import Notif from '../../mixins/Notif'
import PageSort from '../../mixins/PageSort'
import PageImageAvatar from './../PageImageAvatar'
import componentLoader from './../overlay/Loader'
import ClickOutside from 'vue-click-outside'

import Queuer from '../../../utils/Queuer'
import moment from 'moment'
import Tooltip from './../tooltip/tooltipInit'
import componentInbox from '../moderation/Inbox'
// import componentInbox from '../Inbox'

const NB_POSTS_TO_GET = 100

export default {
  name: 'component-moderation',

  components: {
    componentConversations,
    componentDiscussion,
    componentPostsFeed,
    PageImageAvatar,
    componentLoader,
    Tooltip,
    componentInbox
  },

  mixins: [Insights, User, Bots, Pages, Posts, Moderation, Groups, Notif, PageSort],

  directives: {
    ClickOutside
  },

  data() {
    return {
      backgroundLoading:'primary',
      colorLoading:'#fff',
      discussionready: false,
      attachment: [],
      discussionuser: null,
      discussion: null,
      refreshdicussion : null,
      conversationsFromModeration:null,
      idconversation: null,
      chooseReviews: false,
      chooseconversation: false,
      choosemoderation: true,
      selectedTab: 0,
      selectedPages: [],
      linked: [],
      posts: {},
      reviews: null,
      replyReview: null,
      replyContent: null,
      counterDanger: false,
      reviewPercentLoader: null,
      sortReviews: 'most_recent', 
      indexPage: 0,
      pins: null,
      pinsData: {
        data: null,
        pages: null
      },
      activeBadWordsDetection: true,
      badWords: {
        data: []
      },
      badWordList: null,
      popupBadWords: false,
      idReload: 0,
      totalCountComments: 0,
      
      pageFilter: '',
      groups: null,
      selectedGroups: [],
      firstSelectGroup: true,
      showLoader: false,
      // advancedTabs: true,
      filterSelected: false,
      selectAllPages: false,

      refresh: {
        last: moment(),
        enabled: true,
        frequency: 30,
        intervalObj: null,
        intervalObj2: null,
        allowed: [
          0,
          10,
          30, // seconds
          60,
          120,
          240,
          300,
        ],
      },

      eventSourceReviews: null,

      loadingPages: {}
    }
  },

  props: {
    tabsIsMinimize: Boolean
  },

  beforeMount(){
    this.$ga.page(this.$router)
  },

  beforeDestroy() {
    if (!this.refresh.intervalObj) {
      return
    }
    clearInterval(this.refresh.intervalObj)
  },

  mounted() {
    localStorage.setItem('section', 'moderation')
    moment.locale(this.$i18n.locale)
    this.badWordList = localStorage.badWordList 
                        ? JSON.parse(localStorage.badWordList) 
                        : []
  },

  created() {
    new Promise((resolve, reject) => {
      this.fetchGroups()
      resolve()
    })
    .then(this.getPages)
    .then(() => {
      // Get bots
      this.getBots()
    })
    .then(() => {
      if(this.$route.params.moderation && this.$route.params.object_id && this.pagesActive.findIndex(p => p.id == this.$route.params.moderation)) {
        this.selectedTab = this.pagesActive.findIndex(p => p.id == this.$route.params.moderation)
      }
      else {
        if(localStorage.last_selected_page == 'undefined') localStorage.last_selected_page = null
        const firstPage = this.pagesActive.find(p => !this.missingFacebookParent(p)) || this.pagesActive[0]
        this.selectedPages = this.pagesActive
                                    ? (localStorage.last_selected_page && JSON.parse(localStorage.last_selected_page)
                                              ? [JSON.parse(localStorage.last_selected_page)]
                                              : (firstPage ? [firstPage] : []))
                                    : {}
        if(this.selectedPages && !this.pagesActive.find(p => p.id == this.selectedPages[0].id && !this.missingFacebookParent(p))) this.selectedPages = [firstPage] || []
        this.pagesActive = this.pagesActive.filter(p => p.bot_status)
        this.selectedTab = this.pagesActive.findIndex(p => p.id == this.selectedPages[0].id)
      }
      this.selectedPages = [this.selectedTab]
    })
    .then(() => {
      // Create array of pages to be filled
      if(!this.pagesActive[this.selectedTab]) return
      if(this.pagesActive[this.selectedTab].network == "google")
        this.getReviews()
      else if(!["facebook", 'instagram', 'linkedin', 'tiktok'].includes(this.pagesActive[this.selectedTab].network) || !this.activeInbox())
        this.getPosts()
    })
    .then(() => {
      this.pins = localStorage.pins ? JSON.parse(localStorage.pins) : []
      if(!this.pins) this.pins = []
    })
    .then(() => {
      this.initPinsData()
    })
    
      
  },

  computed: {
    // Garde l'index d'origine : la sélection est indexée sur pagesActive
    sortedPagesActive() {
      const pages = (this.pagesActive || []).map((item, index) => ({ item, index }))
      return this.sortByPageName(pages, p => p.item)
    },

    activeModeration(){
      const accounts = [
        'e480002b-1c62-41e6-968f-c09d365b0741', //reworld
        'aed13e10-be3d-4d3b-840f-a1f4765383ac', //newcom-regie
        'abc0a72e-3274-4d30-b0e9-6af7c3e323ba', //deblasi.stefane
      ]
      const user = JSON.parse(localStorage.user)
      const force = localStorage.forceModeration ? JSON.parse(localStorage.forceModeration) : false
      return accounts.includes(user.account) || this.checkLock('moderation') || user.email.includes("@mashup-web.com") || this.activeInstagramStories() || force == true
    },

    pagesActive() {
      //  return this.linked.filter(p => ['instagram', 'facebook', 'linkedin', 'google'].includes(p.network) && !p.isGroup)
       return this.linked.filter(p => (['facebook', 'linkedin', 'google'].includes(p.network) && !p.isGroup && !(p.network == 'facebook' && p.story_config && p.story_config.onlyConciergerie)) || (p.network == 'instagram' && !p.isGroup) || (p.network == 'tiktok' && !p.isGroup && p.story_config && p.story_config.created))
    }
  },

  watch: {
    selectAllPages: function(newVal) {
      if (newVal) {
        this.selectedPages = this.pagesActive.filter(p => ['facebook', 'instagram', 'linkedin', 'tiktok'].includes(p.network) && !this.missingFacebookParent(p)).map(p => this.pagesActive.findIndex(pA => p.id == pA.id))
        this.updateSelected(this.selectedPages.length ? this.selectedPages[0] : null)
      } else {
        const allPagesCount = this.pagesActive.filter(p => ['facebook', 'instagram', 'linkedin', 'tiktok'].includes(p.network) && !this.missingFacebookParent(p)).length
        if (this.selectedPages.length === allPagesCount) {
          this.selectedPages = []
          this.updateSelected(null)
        }
      }
    },

    badWordList(){
      localStorage.setItem('badWordList', JSON.stringify(this.badWordList))
      this.badWords.data = []
    },

    'refresh.frequency': function(freq) {
      this.reloadDiscussion()
    },

    selectedPages(newVal) {
      
      if(this.selectedPages && this.selectedPages.length == 0) this.filterSelected = false

      this.selectAllPages = this.selectedPages.length == this.pagesActive.filter(p => ['facebook', 'instagram', 'linkedin', 'tiktok'].includes(p.network)).length
      
      this.selectedGroups = (this.groups || []).map(g => g.pages.includes(this.selectedPages.find(pId => this.pagesActive[pId])?.id));

      (this.groups || []).forEach(g => {
        if(this.selectedPages.filter(pageId => g.pages.includes(this.pagesActive[pageId]?.id)).length == g.pages.length){
          if(!this.selectedGroups.includes(g.id) && document.getElementById(`groups-${g.id}`)) {
            this.selectedGroups.push(g.id)
            document.getElementById(`groups-${g.id}`).checked = true
          }
        }
        else {
          if(this.selectedGroups.includes(g.id) && document.getElementById(`groups-${g.id}`)) {
            this.selectedGroups.splice(this.selectedGroups.findIndex(s => s == g.id), 1)
            document.getElementById(`groups-${g.id}`).checked = false
          }
        }
      })

      console.log("selectedPages test", newVal)
      if (Array.isArray(newVal)) {
        this.$store.commit('selectPage/updatePagesSelected', {
          pagesId: Object.values(this.$store.getters['selectPage/selectPageAllPages']).filter(page => newVal.some(indexPageActive => this.pagesActive[indexPageActive] && this.pagesActive[indexPageActive].id == page.id)).map(p => p.id)
        });
      }
    }
  },

  methods: {

    updateLoadingPages(loadings) {
      this.loadingPages = loadings
      this.$forceUpdate()
    },  

    isProd() {
      return process.env.VUE_APP_API_HOST == 'https://api.saas.mashup-web.com'
    },

    activeInbox() {
      // to remove
      // let linkedinSelected = this.selectedPages.find(s => this.pagesActive[s].network == 'linkedin')
      // if(linkedinSelected >= 0 && this.isProd()) {
      //   return false
      // }

      // const accounts = [
      //   'd12717da-7255-4d0d-a77c-417578e016a8', //sandbox test
      //   '8478452f-909b-4775-a2b4-329fbd0a90ec', //cyber-id
      //   '9e046e84-5b26-4c94-8379-9a88ea278490', //ledivan,
      //   '57524522-10fc-414d-9d5b-852a57d67780', //fb permission
      // ]
      // const user = this.user ? this.user
      //                         : (localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null)
      // const force = localStorage.forceInbox ? JSON.parse(localStorage.forceInbox) : false
      // return user && (accounts.includes(user.account) || user.email.includes("@mashup-web.com") || this.activeInstagramStories() || force == true)

      return true
    },

    activeInstagramStories() {
        const accounts = [
            '63fc164e-60da-41a7-9619-0c5fe6561239', //next-plz
            'b0291610-4743-4420-91ee-ea5699647106', //motoblouz
            'a8276ad6-bfe0-4866-a5b0-9fbf14003b27', //objectifgard
            '1863bfe3-f179-49a5-8baa-b1edb7e3282d', //doorinsider
            '9b76ba80-38e5-4b8f-9705-6aaf5259b946', //iadfrance
            '36522076-7ed1-4964-8323-1fd8d773012f', //agenceqg
            '7f0e5b02-a627-432f-89eb-83317b03e478', //santeclair.fr
            '90e789fa-7377-434c-b719-132aa8bcd1d2',  //keepeo.fr
            'cbdec673-84ab-401b-8882-0a72fa29b510',  //archi-tech.digital
            '6a1edfc6-eed2-4945-a48b-5be437a5e955',  //uncertainnicolas
            '411af69b-6839-421f-87d3-2cac55a5cbb3', //auto123
            '485a2ce9-b925-4962-a7eb-3abefebfd134', //komeocreation
        ]

        const user = JSON.parse(localStorage.user)
        return accounts.includes(user.account) || this.checkLock('instagram_credentials') || this.checkLock('conciergerie') || user.email.includes("@mashup-web.com")
    },

    showInbox(){
      if (!this.pagesActive) return false
      if (!this.selectedPages.length) return true
      return this.pagesActive[this.selectedTab] && ['facebook', 'instagram', 'linkedin', 'tiktok'].includes(this.pagesActive[this.selectedTab].network)
    },

    toggleExpandTabs() {
      // this.advancedTabs = !this.advancedTabs
      this.$emit('minimizeTabs', !this.tabsIsMinimize)
    },

    contractTabs(){
      // this.advancedTabs = false
      this.$emit('minimizeTabs', true)
    },

    /** check page filter **/
    checkPageFilter(page){
      return page.name.toLowerCase().includes(this.pageFilter.toLowerCase()) || page.network.toLowerCase().includes(this.pageFilter.toLowerCase()) || (this.pageInGroup(page) && this.pageInGroup(page).name.toLowerCase().includes(this.pageFilter.toLowerCase()))
    },

    checkSelected(page) {
      if(!this.filterSelected)
        return true
      else 
        return this.selectedPages.map(s => this.pagesActive[s]).find(s => s.id == page.id)
    },

    accessNotActived(page) {
      return (page.network == 'instagram' && page.isGroup) || !page.bot_status
    },

    // La modération Instagram passe par la page Facebook liée, qui doit être accessible
    missingFacebookParent(page) {
      return !!page && page.network == 'instagram' && !this.linked.find(f => page.affected_to == f.network_id)
    },

    pageUnavailable(page) {
      return !this.checkLock(page.network) || this.accessNotActived(page) || this.missingFacebookParent(page)
    },

    pageTooltip(page) {
      return this.missingFacebookParent(page) ? this.$t('dash.moderation.instagram-missing-facebook') : page.name
    },

    confirmActiveAccess(page){
      this.$vs.dialog({
        type:'confirm',
        color: 'primary',
        title: this.$t('dash.pages.refresh.no-api.title'),
          text: this.$t(`dash.pages.refresh.no-api.description`),
        cancelText: this.$t('dash.pages.refresh.no-api.btn-cancel'),
        acceptText: this.$t('dash.pages.refresh.no-api.btn-OK'),
        accept: async () => {     
          location.assign(`/?refresh-token=${page.id}#/dash/bots`)
        }
      })
    },

    fetchGroups() {
      if(localStorage.groups) this.groups = JSON.parse(localStorage.groups)
      let hideGroups = localStorage.hideGroups ? JSON.parse(localStorage.hideGroups) : []
      if(localStorage.pages && JSON.parse(localStorage.pages) && JSON.parse(localStorage.pages).length > 1)
        this.getGroups().then(res => {
          this.groups = res.map(group => {
            // return {...group, show: true}
            return {...group, show: !hideGroups.find(g => g == group.id)}
          })
          localStorage.groups = JSON.stringify(this.groups)
          this.groups = this.groups.map(g => {
            return {
              ...g,
              pages: g.pages.filter(page => this.pagesActive.find(p => p.id == page))
            }
          })
        })
      else this.groups = []
    },

    toggleShowGroup(group) {
      let hideGroups = localStorage.hideGroups ? JSON.parse(localStorage.hideGroups) : []
      if(group.show)
        hideGroups.push(group.id)
      else 
        hideGroups = hideGroups.filter(g => g != group.id)
      localStorage.setItem('hideGroups', JSON.stringify(hideGroups))
      
      let index = this.groups.findIndex(g => g.id == group.id)
      this.$set(this.groups[index], 'show', !group.show)
    },

    checkAllPagesGroupSelected(group){
      let countPages = this.selectedPages.filter(p => group.pages.includes(this.pagesActive[p].id)).length
      return 0 < countPages && countPages < group.pages.length
    },

    checkGroup(group){
      if(this.selectedGroups.includes(group.id)){
        console.log('add page from', group.id)

        let checkPage = (p) => this.checkLock(p.network) && ['facebook', 'instagram', 'linkedin', 'tiktok'].includes(p.network) && !this.missingFacebookParent(p) // && p.bot_status
        const currentMultiPages = this.selectedPages.filter(p => ['facebook', 'instagram', 'linkedin', 'tiktok'].includes(this.pagesActive[p].network))
        this.selectedPages = this.firstSelectGroup
                                ? this.pagesActive.filter(p => group.pages.includes(p.id) && checkPage(p)).map(p => this.pagesActive.findIndex(pA => p.id == pA.id))
                                : [...new Set(currentMultiPages.concat(this.pagesActive.filter(item => group.pages.includes(item.id) && checkPage(item)).map(p => this.pagesActive.findIndex(pA => p.id == pA.id))))]
        this.firstSelectGroup = false
        this.selectedPages = [...new Set(this.selectedPages.concat(this.pagesActive.filter(item => group.pages.includes(item.id) && checkPage(item)).map(p => this.pagesActive.findIndex(pA => p.id == pA.id))))]

        // for(let b of this.selectedPages){
        //   let botsPage = this.posts.filter(p => p.pages.id == b.id)
        //   if(botsPage.length > 1) 
        //     this.selectedPages = this.selectedPages.filter(p => !botsPage.slice(1).map(bPage => bPage.id).includes(p.id))
        // }
      }
      else {
        console.log('remove page from', group.id)
        this.selectedPages = this.selectedPages.filter(p => !group.pages.includes(this.pagesActive[p].id))
      }
      
      this.updateSelected(this.selectedPages.length ? this.selectedPages[0] : null)
    },

    findPage(pageId) {
      return this.pagesActive.find(p => p.id == pageId)
    },

    pageInGroup(page) {
      return this.groups.find(g => g.pages.includes(page.id))
    },

    checkPagesInGroup(group) {
      return group.pages.some(p => this.findPage(p))
    },

    checkGroupFilter(group){
      if(!group) return false
      return group.pages.every(p => {
        if(!this.findPage(p)) return true
        return !this.findPage(p) || (this.findPage(p) && (!this.checkPageFilter(this.findPage(p)) || !this.checkSelected(this.findPage(p))))
      })
    },

     openLoadingContained(){
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: this.$refs.loadableButtonicla,
        scale: 0.45
      })
    },

    openLoadingInDiv(){
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 0.6
      })
      setTimeout( ()=> {
        this.$vs.loading.close('#div-with-loading > .con-vs-loading')
      }, 3000);
    },

    async findConversations() {
      const f = async () => {
        if (this.refresh.enabled && document.visibilityState === 'visible') {
          this.showConversations()
        }
        this.refresh.last = moment()
      }
      this.refresh.intervalObj2 = setInterval(f, this.refresh.frequency * 1000)
      f()
    },

    showConversations(){
      this.getConversations(this.pagesActive[this.selectedTab]).then(res =>{
        console.log('getConversations showConversations moderation', res)

        if(res.body.error && res.body.error.toString() != '') {
          this.notify({
            title:this.$t('dash.moderation.notification.error'),
            text:this.$t(res.body.error.toString()),
            color:'primary',
            time: 4000,
            id: this.pagesActive[this.selectedTab].id
          }, {
            component: "Moderation",
            action: "getConversations",
            params: {
              page: this.pagesActive[this.selectedTab].name,
              network: this.pagesActive[this.selectedTab].network
            }
          })
        }

        if(res.body.conversations.data && res.body.conversations.data.length > 0)
        { 
            console.log('on a des conversations')
          
            this.conversationsFromModeration = res.body.conversations
            this.choosemoderation = false
            this.chooseconversation = true

          if(this.conversationsFromModeration && this.conversationsFromModeration.data && this.conversationsFromModeration.data.length && !this.discussion) {
            let discussion = this.conversationsFromModeration.data[0]
            let IdUserTab = this.pagesActive[this.selectedTab].network == 'instagram' ? 1 : 0
            this.showDiscussion(discussion.id, discussion.participants.data[IdUserTab].id)
          }
        }
       else {
        if (this.refresh.intervalObj2) {
          clearInterval(this.refresh.intervalObj2)
          this.refresh.intervalObj2 = null
        } 

       if(res.body.conversations.error){
          this.notify({
            title:this.$t('dash.moderation.notification.error'),
            text:res.body.conversations.error.message,
            color:'primary',
            time: 4000,
            id: this.pagesActive[this.selectedTab].id
          }, {
            component: "Moderation",
            action: "getConversations",
            params: {
              page: this.pagesActive[this.selectedTab].name,
              network: this.pagesActive[this.selectedTab].network
            }
          })
          console.log('error')}
       else if(res.body.conversations.nofb){
          this.notify({
            title:this.$t('dash.moderation.notification.nofb'),
            text:'',
            color:'primary',
            time: 4000,
            id: this.pagesActive[this.selectedTab].id
          }, {
            component: "Moderation",
            action: "getConversations",
            params: {
              page: this.pagesActive[this.selectedTab].name,
              network: this.pagesActive[this.selectedTab].network
            }
          })
          console.log('nofb')}
        else if(res.body.conversations.noconvnofollower){
          this.notify({
            title:this.$t('dash.moderation.notification.noconvnofollower'),
            text:'',
            color:'primary',
            time: 4000,
            id: this.pagesActive[this.selectedTab].id
          }, {
            component: "Moderation",
            action: "getConversations",
            params: {
              page: this.pagesActive[this.selectedTab].name,
              network: this.pagesActive[this.selectedTab].network
            }
          })
          console.log('noconvnofollower')}
         else if(res.body.conversations.nolinkedin){
          this.notify({
            title:this.$t('dash.moderation.notification.nolinkedin'),
            text:'',
            color:'primary',
            time: 4000,
            id: this.pagesActive[this.selectedTab].id
          }, {
            component: "Moderation",
            action: "getConversations",
            params: {
              page: this.pagesActive[this.selectedTab].name,
              network: this.pagesActive[this.selectedTab].network
            }
          })
          console.log('nolinkedin')}
       else {
          this.notify({
            title:this.$t('dash.moderation.notification.noconversations'),
            text:'',
            color:'primary',
            time: 4000,
            id: this.pagesActive[this.selectedTab].id
          }, {
            component: "Moderation",
            action: "getConversations",
            params: {
              page: this.pagesActive[this.selectedTab].name,
              network: this.pagesActive[this.selectedTab].network
            }
          })
          console.log('pas de conversations')}
       }
        
      })
    },

    log() {
      console.log(...arguments)
    },

    dateFormat(date){
      return moment(date).local(this.$i18n.locale).format('LLL')
    },

    dateFromNow(date){
      return moment(date).fromNow(0)    
    },

    async getReviews(){
      this.showLoader = true
      this.reviewPercentLoader = 0
      this.reviews = null

      if(this.eventSourceReviews) 
        this.eventSourceReviews.close();

      this.eventSourceReviews = new EventSource(`${process.env.VUE_APP_API_HOST}/moderation/reviews?page=${this.pagesActive[this.selectedTab].id}`);
      this.eventSourceReviews.onopen = () => {
        console.log("opened");
      };
      this.eventSourceReviews.onerror = (error) => {
        console.log("error", error);
        this.eventSourceReviews.close();
      };
      
      this.eventSourceReviews.onmessage = (event) => {
        console.log('message', event)
        this.reviewPercentLoader = 100
        this.showLoader = false
        let data = JSON.parse(event.data)
        if(data.reviews && data.reviews.reviews){
          this.reviews = data.reviews
          this.sortReviewsBy(this.sortReviews)
          this.reviewPercentLoader = Math.floor(this.reviews.reviews.length / this.reviews.totalReviewCount * 100)
          if(this.reviewPercentLoader == 100) this.showLoader = false
        }
        else {
          if(data.reviews && data.reviews.error) 
            this.notify({
              title:this.$t('dash.moderation.notification.error'),
              text:this.$t(data.reviews.error.message),
              color:'primary',
              id: this.pagesActive[this.selectedTab].id
            }, {
              component: "Moderation",
              action: "getReviews",
              params: {
                page: this.pagesActive[this.selectedTab].name,
                network: this.pagesActive[this.selectedTab].network
              }
            })
          // this.reviewPercentLoader = 100
          // this.showLoader = false
        }
      }
    },

    sortReviewsBy(sort){
      this.sortReviews = sort
      // sort by default by date 
      this.reviews.reviews = this.reviews.reviews.sort((a,b) => {
        if(moment(a.updateTime).isBefore(moment(b.updateTime)))
          return 1
        else if(moment(a.updateTime).isAfter(moment(b.updateTime)))
          return -1
        return 0
      })
      switch(sort){
        // case 'most_recent':
        //   this.reviews.reviews = this.reviews.reviews.sort((a,b) => {
        //     if(moment(a.updateTime).isBefore(moment(b.updateTime)))
        //       return 1
        //     else if(moment(a.updateTime).isAfter(moment(b.updateTime)))
        //       return -1
        //     return 0
        //   })
        //   break
        case 'best':
          this.reviews.reviews = this.reviews.reviews.sort((a,b) => {
            if(a.starRating < b.starRating)
              return 1
            else if(a.starRating > b.starRating)
              return -1
            return 0
          })
          break
        case 'least_good':
          this.reviews.reviews = this.reviews.reviews.sort((a,b) => {
            if(a.starRating < b.starRating)
              return -1
            else if(a.starRating > b.starRating)
              return 1
            return 0
          })
          break
        default:
      }
      
    },

    openReplyToReview(review, type) {
      this.replyReview = review
      this.replyReview.type = type
      this.replyContent = type == 'add' ? '' : review.reviewReply.comment
    },

    async sendReplyToReview(review) {
      await this.replyToReview(this.pagesActive[this.selectedTab], review, this.replyContent)
      
      let index = this.reviews.reviews.findIndex(r => r.reviewId == review.reviewId)
      review = {
        ...review,
        reviewReply: {
          comment: this.replyContent,
          updateTime: moment().format(),
        }
      }
      this.$set(this.reviews.reviews, index, review)

      this.replyReview = null
      this.replyContent = null
    },

    async deleteReplyToReview(review) {
      await this.removeReplyToReview(this.pagesActive[this.selectedTab], review)

      let index = this.reviews.reviews.findIndex(r => r.reviewId == review.reviewId)
      delete review.reviewReply
      
      this.$set(this.reviews.reviews, index, review)
    },
    
  
    getPosts(){
      this.showLoader = true

      this.getPostsFromRS(this.pagesActive[this.selectedTab]).then(res => {
        console.log('resss', res)
        this.showLoader = false
        const { success, error } = res.body

        if (!success || success !== true) {
          this.posts = {}
          return
        }

        this.posts = res.body.posts
        this.posts.pages = this.pagesActive[this.selectedTab]

        if(this.posts.pages.network == 'linkedin' && this.posts.paging.links.find(l => l.rel == 'next'))
          this.paginationPosts()

      })
    },

    addCountComments(countComments){
      this.totalCountComments += countComments
    },

    paginationPosts(type='next') {

      if(this.pagesActive[this.selectedTab].network == 'facebook' || this.pagesActive[this.selectedTab].network == 'instagram' ){
      console.log('posts paging next :' , this.posts.paging.next)
      let link = type == 'next' 
                  ? this.posts.paging.next
                  : this.posts.paging.previous

      this.showLoader = true

      this.getPreviousNextNodePageFromRS(link).then(res => {
        this.showLoader = false
        
        console.log('resMore', res)

        if(this.pagesActive[this.selectedTab].network == 'instagram'){
         for(var i = 0; i<res.body.data.length; i++){
                    res.body.data[i].created_time = res.body.data[i].timestamp
                    res.body.data[i].message = res.body.data[i].caption
                    res.body.data[i].full_picture = res.body.data[i].media_url
                    res.body.data[i].comment_count = res.body.data[i].comments_count
                    if(res.body.data[i].thumbnail_url){
                      res.body.data[i].full_picture = res.body.data[i].thumbnail_url
                    }
         }
        }

        this.$set(this.posts, 'data', this.posts.data.concat(res.body.data))
        this.$set(this.posts, 'paging', res.body.paging ? res.body.paging : null)

        })
       }
      if(this.pagesActive[this.selectedTab].network == 'linkedin'){
        let link
        
        if(this.posts.paging.links.find(l => l.rel == 'next')){
          link = this.posts.paging.links.find(l => l.rel == 'next').href
          console.log('posts paging next :' , link)
          link = link.replace(/&/g, "-")
        }
        else
          return

      this.showLoader = true

      this.getPreviousNextNodePageFromRSLinkedin(this.pagesActive[this.selectedTab], link).then(res => {
        this.showLoader = false
        
        console.log('resMore', res)

        this.$set(this.posts, 'data', this.posts.data.concat(res.body.posts.data))
        this.$set(this.posts, 'paging', res.body.posts.paging ? res.body.posts.paging : null)

        })
      }

    },

    addPostLike(postId){
      let index = this.posts.data.findIndex(post => post.id == postId)
      if(this.posts.pages.network == 'linkedin')
        this.posts.data[index].like_count++
      else {
        this.posts.data[index].likes.summary.total_count++
        this.posts.data[index].likes.summary.has_liked = true
      }
    },
    
    deleteCommentWithBadWord(commentId){
      let index = this.badWords.data.findIndex(d => d.comment.id == commentId)
      this.badWords.data.splice(index, 1)
      this.idReload++
    },

    async switchComment(postid, postis_comment_enable){
        console.log('dans switchcomment moderation.vue', postid, postis_comment_enable)
        await this.switchComments(this.pagesActive[this.selectedTab], postid, postis_comment_enable)
        this.getPosts()
    },

    async findDiscussion() {
      const f = async () => {
        if (this.refresh.enabled && document.visibilityState === 'visible') {
          this.discussion = await this.getDiscussion(this.pagesActive[this.selectedTab], this.idconversation)
        }
        this.refresh.last = moment()
      }
      this.refresh.intervalObj = setInterval(f, this.refresh.frequency * 1000)
      f()
    },

    async showDiscussion(conversationid, conversationuserid){
      this.idconversation = conversationid

      console.log('entrer dans showdiscussion moderation',this.pagesActive[this.selectedTab],conversationid)
      this.discussionuser = await this.getUser(this.pagesActive[this.selectedTab], conversationuserid)
      await this.findDiscussion()

      console.log('entrer dans showdiscussion postmessage lu:', this.discussion.data.discussion.data[0].to.data[0].id, this.pagesActive[this.selectedTab].network_id)
      let recipientId = null
      if(this.discussion.data.discussion.data[0].from.id != this.pagesActive[this.selectedTab].network_id){
                recipientId = this.discussion.data.discussion.data[0].from.id
      }
      else{
         recipientId = this.discussion.data.discussion.data[0].to.data[0].id
      }

      console.log('moderation.vue  recherche des pieces jointes')
      console.log(this.discussion.body.discussion.data[0].id)
      
      console.log('this discussion moderation.vue',this.discussion)
      console.log('this user moderation.vue', this.discussionuser)
    },

    async reloadDiscussion() {
      if (this.refresh.intervalObj) {
        clearInterval(this.refresh.intervalObj)
        this.refresh.intervalObj = null
      }
      if (this.refresh.intervalObj2) {
        clearInterval(this.refresh.intervalObj2)
        this.refresh.intervalObj2 = null
      }      
      await this.findConversations()
      if (this.discussion) {
        await this.findDiscussion()
      }
    },

    async messageSend( formdata){
      console.log('entrer dans messageSend moderation', this.discussion.data.discussion.data[0].to.data[0].id, this.pagesActive[this.selectedTab].network_id)
      let recipientId = null
      for (var value of formdata.values()) {
      console.log("formdata", value);
      }      
      if(this.discussion.data.discussion.data[0].from.id != this.pagesActive[this.selectedTab].network_id){
        recipientId = this.discussion.data.discussion.data[0].from.id
      }
      else{
         recipientId = this.discussion.data.discussion.data[0].to.data[0].id
      }
      await this.sendMessage(this.pagesActive[this.selectedTab], recipientId, formdata)
      this.discussion = await this.getDiscussion(this.pagesActive[this.selectedTab], this.idconversation)
      this.refreshdicussion += 1
    },
    async reactToMessage( discussionid, react){
      console.log('entrer dans reactomessage moderation', discussionid, this.pagesActive[this.selectedTab].network_id)
      console.log('react = ', react)
      let recipientId = null
    
      if(this.discussion.data.discussion.data[0].from.id != this.pagesActive[this.selectedTab].network_id){
        recipientId = this.discussion.data.discussion.data[0].from.id
      }
      else{
         recipientId = this.discussion.data.discussion.data[0].to.data[0].id
      }
      await this.reactMessage(this.pagesActive[this.selectedTab], recipientId, discussionid, react)
      this.discussion = await this.getDiscussion(this.pagesActive[this.selectedTab], this.idconversation)
      this.refreshdicussion += 1
    },
    badWordsDetected(post, comment, badWords){
      this.badWords.data.push({post, comment, badWords, page: this.pagesActive[this.selectedTab]})
    },

    removeChipBadWord(item) {
      this.badWordList.splice(this.badWordList.indexOf(item), 1)
    },

    addPin(node){
      this.pins.push({ ...node, page: this.pagesActive[this.selectedTab]})
      localStorage.setItem('pins', JSON.stringify(this.pins))
      this.initPinsData()
    },

    removePin(node){
      console.log('removePin')
      this.pins.splice(this.pins.findIndex(post => post.id == node.id), 1)
      localStorage.setItem('pins', JSON.stringify(this.pins))
      this.initPinsData()
    },

    initPinsData(){
      this.pinsData = {
        data: this.pins.filter(p => p.page && p.page.id == this.pagesActive[this.selectedTab].id),
        pages: this.pagesActive[this.selectedTab]
      }
    },

    /**
     * Retrieve filter
     * @param {Object} obj - radio object
     */
    updateSelected: function(tab) {

      clearInterval(this.refresh.intervalObj)
      this.refresh.intervalObj = null
      clearInterval(this.refresh.intervalObj2)
      this.refresh.intervalObj2 = null

      this.conversationsFromModeration = null

      this.selectedTab = tab
      console.log('this.selectedPages', this.selectedPages)
      if (tab === null || tab === undefined || !this.pagesActive[tab]) return
      if(!['facebook', 'instagram', 'linkedin', 'tiktok'].includes(this.pagesActive[tab].network) || !this.activeInbox())
        this.selectedPages = [tab]
      else
        this.selectedPages = this.selectedPages.filter(p => ['facebook', 'instagram', 'linkedin', 'tiktok'].includes(this.pagesActive[p].network))
        
      console.log('this.selectedPages', this.selectedPages)
      

      this.choosemoderation = true

      this.chooseconversation = false

      this.badWords.data = []

      this.posts = {}
      this.pinsData = {
        data: null,
        pages: null
      }

      if(!this.activeInbox() || (this.activeInbox() && !['facebook', 'instagram', 'linkedin', 'tiktok'].includes(this.pagesActive[tab].network))){
        if(this.pagesActive[tab].network == "google"){
          this.chooseReviews = true
          this.choosemoderation = false
          this.getReviews()
        }
        else
          this.getPosts()

        this.discussion = null

        this.totalCountComments = 0
        
        this.initPinsData()
      }
      scrollTo({ top: 0, left: 0, behavior: 'smooth' })

      // this.contractTabs()
      
      localStorage.setItem('last_selected_pages', JSON.stringify([this.pagesActive[tab]]))
      localStorage.setItem('last_selected_page', JSON.stringify(this.pagesActive[tab]))
    },

    getPages() {
      
      this.getBots()
      let linkedPages = JSON.parse(localStorage.pages)
      new Promise((resolve, reject) => {
        linkedPages = linkedPages.slice().sort((a,b) => {
          if(
              (
                this.bots.some(bot => bot.page.id == a.id) 
                && 
                this.bots.some(bot => bot.page.id == b.id)
              )
              || 
              (
                !this.bots.find(bot => bot.page.id != a.id) 
                && 
                !this.bots.find(bot => bot.page.id != b.id)
              )
            ){
            return (a.name > b.name) ? 1 : ((a.name < b.name) ? -1 : 0)
          }
          else if(this.bots.some(bot => bot.page.id == a.id)){
            return -1
          }
          else if(this.bots.some(bot => bot.page.id == b.id)){
            return 1
          }
        })
        resolve()
      })
      .then(() => {
        //sort by bots updated_at
        linkedPages = linkedPages.slice().sort((a,b) => {
          let botsA = this.bots.filter(bot => bot.page.id == a.id).sort((aB,bB) => (aB.updated_at < bB.updated_at) ? 1 : ((aB.updated_at > bB.updated_at) ? -1 : 0))
          let botsB = this.bots.filter(bot => bot.page.id == b.id).sort((aB,bB) => (aB.updated_at < bB.updated_at) ? 1 : ((aB.updated_at > bB.updated_at) ? -1 : 0))
          if(botsA.length == 0 && botsB.length == 0) return 0 
          else if(botsA.length > 0 && botsB.length == 0) return -1
          else if(botsA.length == 0 && botsB.length > 0) return 1
          else if(botsA[0].updated_at < botsB[0].updated_at) return 1
          else if(botsA[0].updated_at > botsB[0].updated_at) return -1
          else return 0
        })
        this.linked = linkedPages.slice()
      })
      .then(() => {

        if(this.activeInbox()) {

          this.countWaitingEvents(this.user.account).then((res) => {
            console.log(res)
            if(res && res.body && res.body.pages) {
              res.body.pages.map(p => {
                let ind = this.linked.findIndex(c => c.id == p.id)
                if(ind >= 0)
                  this.$set(this.linked[ind], 'count_events', p.count)
              })
              this.$forceUpdate()
            }
          })
        }
      })
    },

    updateCountEvents(pageId = null) {
      if(this.activeInbox()) {
        const pages = pageId ? [{ id: pageId }] : null
        this.countWaitingEvents(pages ? null : this.user.account, pages).then((res) => {
          console.log(res)
          if(res && res.body && res.body.pages) {
            res.body.pages.map(p => {
              let ind = this.linked.findIndex(c => c.id == p.id)
              if(ind >= 0)
                this.$set(this.linked[ind], 'count_events', p.count)
            })
            this.$forceUpdate()
          }
        })
      }
    },

    async getBots() {
      this.bots = JSON.parse(localStorage.bots)
    },
  }

}
</script>